/**
 * @generated SignedSource<<a2e70147363932168a6343344f3ded31>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InspectionStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
export type InspectionfieldStateEnum = "APPROVED" | "ASSIGNED" | "IN_PROGRESS" | "OPEN" | "PLANNED" | "REJECTED" | "RETRY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type InspectionFormOverview$data = {
  readonly assignedDate: any | null;
  readonly externalId: number | null;
  readonly field: {
    readonly year: number;
  } | null;
  readonly id: string;
  readonly inspectionforms: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly year: number;
      } | null;
    } | null>;
  } | null;
  readonly latestInspection: {
    readonly id: string;
    readonly inspectionform: {
      readonly id: string;
      readonly year: number;
    } | null;
    readonly lastModified: any | null;
    readonly state: InspectionStateEnum | null;
  } | null;
  readonly managementPackageVariant: {
    readonly code: string;
    readonly managementPackage: {
      readonly name: string;
    } | null;
    readonly name: string;
  } | null;
  readonly plannedDate: any | null;
  readonly state: InspectionfieldStateEnum | null;
  readonly year: number;
  readonly " $fragmentType": "InspectionFormOverview";
};
export type InspectionFormOverview$key = {
  readonly " $data"?: InspectionFormOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"InspectionFormOverview">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InspectionFormOverview",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    },
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assignedDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectNode",
      "kind": "LinkedField",
      "name": "managementPackageVariant",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ManagementPackageNode",
          "kind": "LinkedField",
          "name": "managementPackage",
          "plural": false,
          "selections": [
            (v3/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionNode",
      "kind": "LinkedField",
      "name": "latestInspection",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastModified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InspectionFormNode",
          "kind": "LinkedField",
          "name": "inspectionform",
          "plural": false,
          "selections": (v4/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InspectionFormNodeConnection",
      "kind": "LinkedField",
      "name": "inspectionforms",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InspectionFormNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "InspectionFormNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FieldNode",
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "InspectionfieldNode",
  "abstractKey": null
};
})();

(node as any).hash = "2c38b3d77938917d61c9831758b5b10c";

export default node;
